//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import httpApi from "../../api/cashier";
import { Toast } from "mint-ui";
import wx from "weixin-js-sdk";

// 转账授权服务协议弹窗内容（结构化，便于与样式分离与后续维护）
const AGREEMENT_SECTIONS = [
    {
        title: '一、协议主体与适用范围',
        groups: [
            { subTitle: '1.1 协议主体', lines: [
                '甲方：财付通支付科技有限公司（以下简称 “财付通” 或 “微信支付”）',
                '乙方：已开通微信支付服务的商户（以下简称 “商户”）',
                '丙方：微信支付用户（以下简称 “用户”）'
            ]},
            { subTitle: '1.2 适用范围', lines: [
                '本说明适用于 2025 年 1 月 15 日正式上线的新版商家转账产品中的用户授权免确认模式。商户开通此服务需同时遵守：',
                '《微信支付服务协议》',
                '《微信支付运营功能服务协议》',
                '《商家转账开通申请承诺函》',
                '《微信支付用户服务协议》',
                '微信支付商户平台发布的其他相关规则和公告'
            ]}
        ]
    },
    {
        title: '二、服务定义与流程',
        groups: [
            { subTitle: '2.1 服务定义', lines: [
                '商家转账免授权（免确认收款）服务是指：商户在自建的用户登录 / 收款流程中，拉起微信官方授权页面，由用户确认授权收款方式。授权后，商户再次向该用户发起转账时，无需用户逐笔返回商户页面确认收款，资金将直接转入用户微信零钱账户。'
            ]},
            { subTitle: '2.2 适用场景', lines: [
                '适用于用户需多次收款或需完成审核后才可转账的场景，如：',
                '佣金报酬发放',
                '行政补贴、保险理赔',
                '现金营销活动',
                '退款、返现等'
            ]},
            { subTitle: '2.3 授权流程', lines: [
                '商户可选择以下任意一种方式发起授权申请：',
                '方式一：发起转账并获取授权',
                '商户调用 “发起转账并完成免确认收款授权” 接口',
                '拉起微信官方用户确认收款页面',
                '用户点击 “确认收款” 即完成授权',
                '本次转账自动入账，后续转账无需确认',
                '方式二：直接申请授权',
                '商户调用 “发起免确认收款授权” 接口',
                '拉起微信官方免确认收款授权页面',
                '用户点击 “同意授权” 即完成授权',
                '商户后续可调用 “用户授权后转账” 接口直接转账'
            ]},
            { subTitle: '2.4 技术限制', lines: [
                '授权申请有效期：24 小时',
                '未确认授权记录保留期：30 天',
                '同一微信号在同一商户下：最多 5 个待确认或已生效授权单',
                '接口频率限制：50 次 / 秒（单个商户）'
            ]}
        ]
    },
    {
        title: '三、商户的权利与义务',
        groups: [
            { subTitle: '3.1 商户权利', lines: [
                '在用户授权有效期内，无需用户逐笔确认即可发起转账',
                '通过 API 查询用户授权状态和历史记录',
                '通过 API 主动关闭用户授权',
                '享受免费的转账服务（无手续费）'
            ]},
            { subTitle: '3.2 商户义务', lines: [
                '资质合规：仅限普通商户开通（暂不支持小微商户、个体工商户），且需满足 “入驻满 90 日且近 30 天连续正常交易” 的条件',
                '场景真实：必须按申请时提交的转账场景使用服务，不得擅自变更用途',
                '信息透明：在用户授权前，必须清晰告知用户授权的内容、有效期、转账用途和金额范围',
                '身份核验：确保发起转账的用户身份与授权用户身份一致',
                '数据安全：妥善保管商户号、API 证书、密钥等敏感信息，防止泄露',
                '纠纷处理：承担因自身原因导致的转账错误、重复转账等问题的全部责任'
            ]},
            { subTitle: '3.3 禁止行为', lines: [
                '超出用户授权范围进行转账（如超额、超频转账）',
                '无真实交易背景或虚假交易进行转账',
                '将服务用于非法活动（如赌博、洗钱、欺诈等）',
                '未经用户同意擅自恢复已关闭的授权',
                '向用户收取转账相关的额外费用'
            ]}
        ]
    },
    {
        title: '四、用户的权利与义务',
        groups: [
            { subTitle: '4.1 用户权利', lines: [
                '自主决定是否同意授权',
                '随时在微信客户端查看授权记录',
                '随时主动关闭授权服务（关闭后商户无法再发起免确认转账）',
                '对异常转账提出异议并要求商户和微信支付协助处理',
                '要求商户提供转账明细和相关凭证'
            ]},
            { subTitle: '4.2 用户义务', lines: [
                '妥善保管自己的微信账号和支付密码',
                '授权前仔细阅读并理解授权条款内容',
                '对自己的授权行为负责',
                '如发现账号异常或未经授权的转账，及时通知微信支付客服'
            ]}
        ]
    },
    {
        title: '五、授权的生效、变更与终止',
        groups: [
            { subTitle: '5.1 授权生效', lines: [
                '用户在微信官方授权页面点击 “同意授权” 或 “确认收款” 后，授权立即生效',
                '授权长期有效，除非用户或商户主动关闭'
            ]},
            { subTitle: '5.2 授权变更', lines: [
                '授权内容（如转账用途、金额范围）变更时，商户必须重新获取用户授权',
                '微信支付有权根据风险控制需要，临时冻结或终止异常授权'
            ]},
            { subTitle: '5.3 授权终止', lines: [
                '授权在以下情况下终止：',
                '用户在微信客户端主动关闭授权',
                '商户通过 API 主动关闭授权',
                '用户微信账号被注销或冻结',
                '商户微信支付商户号被注销或冻结',
                '微信支付发现存在安全风险或违规行为'
            ]}
        ]
    },
    {
        title: '六、风险提示与责任划分',
        groups: [
            { subTitle: '6.1 风险提示', lines: [
                '商户风险：如商户系统被入侵或 API 密钥泄露，可能导致恶意转账',
                '用户风险：如用户微信账号被盗，可能导致他人冒用授权进行转账',
                '资金风险：免确认模式下，资金将直接入账，用户无法实时拦截'
            ]},
            { subTitle: '6.2 责任划分', lines: [
                '商户责任：因商户过错（如系统漏洞、操作失误、违规使用）导致的损失，由商户全部承担',
                '用户责任：因用户过错（如账号保管不善、授权不当）导致的损失，由用户自行承担',
                '微信支付责任：因微信支付系统故障或安全漏洞导致的损失，由微信支付在法律规定范围内承担相应责任',
                '不可抗力：因不可抗力导致的损失，各方互不承担责任'
            ]}
        ]
    },
    {
        title: '七、争议解决',
        groups: [
            { subTitle: '', lines: [
                '因本服务产生的争议，各方应首先通过友好协商解决。协商不成的，任何一方均有权向财付通所在地有管辖权的人民法院提起诉讼。'
            ]}
        ]
    },
    {
        title: '八、其他说明',
        groups: [
            { subTitle: '', lines: [
                '本服务为免费服务，微信支付不向商户和用户收取任何转账手续费',
                '商户开通此服务需在微信支付商户平台提交申请并通过审核',
                '微信支付有权根据法律法规、监管要求或业务发展需要，随时修改本协议和相关规则，并通过商户平台公告方式通知商户',
                '本说明仅供参考，具体条款以微信支付官方发布的最新协议文本为准'
            ]}
        ]
    }
];

export default {
    name: "transferAuthorization",
    data() {
        return {
            isloading: false,
            appName: '',
            goodsDetail: {},
            agreementVisible: false,
            agreementSections: AGREEMENT_SECTIONS
        };
    },
    created() {
        this.initData();
    },
    methods: {
        initData() {
            let query = JSON.parse(sessionStorage.getItem("data") || '{}');
            this.goodsDetail = { ...query };
            this.appName = query.app_name || query.subject || '服务方';
        },
        handleAuthorize() {
            if (this.isloading) return;
            this.isloading = true;
            let _this = this;
            let params = { ...JSON.parse(sessionStorage.getItem("data") || '{}') };
            httpApi.wechatConfirmAuth(params).then((res) => {
                this.isloading = false;
                if (res.status != 200) {
                    Toast({
                        message: res.msg || "操作异常，请刷新重试",
                        duration: 2000,
                    });
                    return;
                }
                const query = res.data;
                // 微信小程序 web-view 内不能直接调起 requestMerchantTransfer，
                // 需中转到小程序原生页，由小程婿调用 wx.requestMerchantTransfer
                if (_this.isInWeixinMiniProgram()) {
                    _this.gotoMiniProgramSignPage(query);
                } else {
                    _this.invokeMerchantTransferInBrowser(query);
                }
            }).catch((err) => {
                Toast({
                    message: err.msg || "授权失败，请联系管理员",
                    duration: 2000,
                });
                this.isloading = false;
            });
        },
        // 判断当前 H5 是否运行在微信小程序 web-view 内
        isInWeixinMiniProgram() {
            const ua = (navigator.userAgent || '').toLowerCase();
            return window.__wxjs_environment === 'miniprogram'
                || ua.indexOf('miniprogram') > -1;
        },
        // 小程序内嵌 H5：跳转到小程序签约中转页，由小程序发起 requestMerchantTransfer
         gotoMiniProgramSignPage(query) {
            const _this = this;
            // 优先使用接口 / 后台下发的小程序签约页路径，其次使用业务数据中的 miniapp_sign_url
            const signPath = '/pages/merchantTransferAuth/index';
            const params = [
                'mchId=' + encodeURIComponent(query.mch_id || ''),
                'appId=' + encodeURIComponent(query.appid || ''),
                'package=' + encodeURIComponent(query.package_info || ''),
                'redirect_url=' + encodeURIComponent(location.origin+'/transferSuccess?redirect_url=' + query.redirect_url || '')
            ].join('&');
            const url = signPath + (signPath.indexOf('?') >= 0 ? '&' : '?') + params;

            // wx.miniProgram.getEnv 在 web-view 内可用，用于二次确认环境
            wx.miniProgram.getEnv((envRes) => {
                if (envRes && envRes.miniprogram) {
                    wx.miniProgram.navigateTo({
                        url,
                        fail() {
                            Toast({
                                message: '跳转小程序签约页失败，请重试',
                                duration: 2000
                            });
                        }
                    });
                } else {
                    // 环境误判兜底：退回浏览器端原有 JSAPI 流程
                    _this.invokeMerchantTransferInBrowser(query);
                }
            });
        },
        // 普通微信浏览器 / 公众号内：原有逻辑保持不变
        invokeMerchantTransferInBrowser(query) {
            const _this = this;
            wx.config({
                debug: false,
                appId: query.appid,
                timestamp: query.time_stamp,
                nonceStr: query.nonce_str,
                signature: query.sign
            });
            wx.error(function (err) {
                console.log("错误原因", err);
            });
            wx.ready(function () {
                wx.checkJsApi({
                    jsApiList: ['requestMerchantTransfer'],
                    success: function (res) {
                        if (res.checkResult['requestMerchantTransfer']) {
                            WeixinJSBridge.invoke('requestMerchantTransfer', {
                                mchId: query.mch_id,
                                appId: query.appid,
                                package: query.package_info,
                            }, function (r) {
                                if (r.err_msg === 'requestMerchantTransfer:ok') {
                                    _this.$router.push({ path: '/transferSuccess?redirect_url=' + query.redirect_url });
                                }
                            });
                        } else {
                            alert('你的微信版本过低，请更新至最新版本。');
                        }
                    }
                });
            });
        },
        handleDecline() {
            // 返回上一页或关闭页面
            if (window.history.length > 1) {
                this.$router.go(-1);
            } else {
                window.close();
            }
        },
        viewAgreement() {
            // 点击《转账授权服务协议》，弹出协议弹窗
            this.agreementVisible = true;
            // 防止弹窗背后的页面被一起滚动
            document.body.style.overflow = 'hidden';
        },
        closeAgreement() {
            this.agreementVisible = false;
            document.body.style.overflow = '';
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/transferAuthorization/index.vue